<template>
    <div class="col-md-12">
        <transition name="fade" :duration="1000">
            <div v-show="loading" class="col-md-12 col-md-offset-5" style="position:absolute; top:0">
                <br /><br /><br />
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </transition>
        <div v-if="!loading">

            <CarehomeHeader :carehome-id="carehomeid" :carehome-name="carehomeDto.name"></CarehomeHeader>
            <br />
            <ul class="nav nav-tabs">
                <li class="active"><a href="#patients" data-toggle="tab">Patients</a></li>
                <li><a href="#wards" data-toggle="tab">Wards</a></li>
            </ul>

            <div class="tab-content col-md-12">
                <div class="tab-pane fade active in" id="patients">
                    <br />
                    <carehomepatientlist v-bind:carehomeid="carehomeid" />
                </div>
                <div class="tab-pane fade" id="wards">
                    <br />
                    <carehomewardlist v-bind:carehomeid="carehomeid"></carehomewardlist>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import carehomepatientlist from "./../../carehome-patients/list/carehome-patient-list.scp.html"
    import carehomewardlist from "./../../carehome-wards/list/carehome-ward-list.scp.html"
    import carehomedetails from "./../details/carehome-detail.scp.html"
    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'

    import CarehomeHeader from './../../appcontrols/CarehomeHeader/CarehomeHeader.scp.html'

    

    export default {
        props :['id'],
        data: function () {
            return {
                loading: true,
                carehomeid: "",
                carehomeDto: null
            }
        },
        created: function () {
            this.carehomeid = this.id;
            console.log("Mounted with id " + this.carehomeid);
            //var id = this.$route.params.id;
            //console.log("Mounted with id " + id);
            //this.carehomeid = id;

        },
        mounted: function () {
            
            var dal = new Dal();
            dal.GetCarehome(this.carehomeid).then(data => {
                this.carehomeDto = data;
                this.loading = false;
            });
        },
        components: {
            carehomepatientlist,
            carehomewardlist,
            carehomedetails,
            CarehomeHeader
        }
    }

</script>


// WEBPACK FOOTER //
// carehome-main.scp.html?11cbcc0e